import { useTranslation } from 'react-i18next';

import { SignupContinueData } from '../types';
import { SetPasscodeForm } from './SetPasscodeForm';

interface SignupScreen4Props {
  handleContinue: (dataObj: SignupContinueData) => void;
}

export function SignupScreen4({ handleContinue }: SignupScreen4Props) {
  const { t } = useTranslation();

  const handleContinueForm = (code: string) => {
    const dataObj = {
      progress: 'screen4',
      code,
    };
    handleContinue(dataObj);
  };

  return (
    <>
      <h1 data-testid="set-passcode-title">{t('R037')}</h1>
      <p>{t('R038')}</p>
      <SetPasscodeForm handleContinue={handleContinueForm} />
    </>
  );
}
